module.exports = "/static/assets/26a4170c481d21b71495a42ccf1b491e.png";